/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.ru>
 */

define(
    [
        'jquery',
        'assets/js/modules/View',
        'assets/js/common/router/index',
        'assets/js/modules/popup/AuthPopup',
        'assets/js/modules/popup/Popup',
        'underscore',
        'assets/js/modules/screen',
        'assets/js/modules/ActionInProgressOverlay',
        'assets/js/modules/browser',
        'selectboxit/src/javascripts/jquery.selectBoxIt.min',
        'jquery-ui/jquery-ui'
    ],
    function($, View, router, { default: AuthPopup }, Popup, _, screen, ActionInProgressOverlay, browser) {
        return View.extend({
            // Query params
            PARAM_GALLERY: 'gallery',
            PARAM_PRODUCT_GROUP_NAME: 'productGroupName',
            PARAM_QUERY: 'query',
            PARAM_PER_PAGE: 'perPage',
            PARAM_ORIENTATION: 'orientation',
            PARAM_PAGE: 'page',
            PARAM_COLOR: 'color',
            PARAM_CATEGORIES: 'categories',
            PARAM_CATEGORY_TITLE: 'categoryTitle',

            initialize: function() {
                this.$favoritesIcon = null;
                this.$deleteChosenCategoryButton = this.$el.find('.delete-chosen-gallery-category');
                this.$openFilterButton = $('.mobile-toolbar-filter.category-filter');
                this.$openSearchButton = $('.mobile-toolbar-filter.search-filter');
                this.$mobileSearchFilter = $('.mobile-toolbar-search');
                this.$galleryMainSection = $('#gallery-main-section');
                this.$mobileFilterClose = $('.mobile-filter-header .icon-close');
                this.$filterPopup = this.$el.find('#gallery-options-section');
                this.$applyFilterButton = this.$el.find('.apply-filter-button');
                this.$paginationForm = this.$el.find('.pagination-form');
                this.$paginationFormInput = this.$paginationForm.find('input[name="page"]');
                this.$paginationFormArrow = this.$paginationForm.find('.page-redirector');
                this.$zoomDialog = this.$el.find('#zoom-dialog');
                this.$showFavoritesButton = this.$el.find('#favorites-link');
                this.$searchTemplateInput = this.$el.find('.input-append-field');
                this.$searchTemplateForm = this.$el.find('.gallery-templates-search');
                this.$labelSearchTemplate = this.$el.find('.gallery-label-search');
                this.$colorCriteriaLabel = this.$el.find('.color-picker-label');
                this.$colorCriteriaSelected = this.$el.find('.color-picker-label-selected');
                this.$removeSelectedColor = this.$el.find('.icon-remove');
                this.$filterSearchLabel = this.$el.find('.filter-search-label');

                // Dropdowns
                this.$productCriteria = this.$el.find('[name="product-criteria"]');
                this.$templatesPerPageDropdown = this.$el.find('#per-page');
                this.$productUploadDropdown = this.$el.find('#upload-product-criteria');
                this.$productDesignBlankDropdown = this.$el.find('#create-your-own-design-criteria');
                this.$templateCategoryDropdowns = this.$el.find('.template-categories');

                this.$productSizeRadioContainer = this.$el.find('#gallery-product-criteria');
                this.$productSizeRadio = this.$productSizeRadioContainer.find('input[type=radio]');
                this.$orientationRadio = this.$el.find('#orientation-container input[type=radio]');
                this.$overlayHandlers = this.$el.find('.category-title, .favorites-link');
                this.progressOverlay = new ActionInProgressOverlay();
                this.$categoryCheckbox = this.$el.find('.gallery-category input[type=checkbox]');

                this.$el.find('input[type=checkbox], input[type=radio]').prop('disabled', false);

                this.colorFilterSelectedTemplate = _.template(
                    '<label class="color-picker-label color-picker-label-selected color-picker-label-<%= color %>" style="background-color: #<%= color %>"></label>' +
                        '<i class="icon-remove"></i>'
                );

                /**
                 * @type {Popup}
                 */
                this.zoomPopup = new Popup(this.$zoomDialog, {
                    width: 900
                });

                this.loginPopup = null;

                [
                    this.$productCriteria,
                    this.$templatesPerPageDropdown,
                    this.$templateCategoryDropdowns,
                    this.$productUploadDropdown,
                    this.$productDesignBlankDropdown
                ].forEach(function($dropdown) {
                    $dropdown.selectBoxIt({ autoWidth: false });
                });

                var queryParams = browser.getParameters();

                if (queryParams[this.PARAM_CATEGORY_TITLE]) {
                    this.model.set(this.PARAM_CATEGORY_TITLE, queryParams[this.PARAM_CATEGORY_TITLE]);
                }
            },

            delegateEvents: function() {
                var _this = this;

                this.$openFilterButton.on('click', function() {
                    _this.toggleFilter();
                });

                this.$openSearchButton.on('click', function() {
                    _this.toggleSearch();
                });

                this.$mobileSearchFilter.on('click', '.search-btn', function() {
                    _this.applyFilter(true);
                });

                this.$mobileSearchFilter.on('keydown', 'input', function(e) {
                    if (e.which === 13) {
                        _this.applyFilter();
                    }
                });

                this.$mobileFilterClose.on('click', function() {
                    _this.toggleFilter();
                });

                this.$deleteChosenCategoryButton.on('click', function() {
                    _this.deleteChosenCategory();
                });

                this.$applyFilterButton.on('click', function() {
                    _this.applyFilter(true);
                });

                // Disable form submit on "enter" keyboard button
                this.$paginationForm.on('submit', function(e) {
                    e.preventDefault();
                });

                this.$filterSearchLabel.on('click', function(e) {
                    let filter_id = e.currentTarget.dataset.filter_id;
                    let hiddenSearchInput = $('input[data-filter_id="' + filter_id + '"]');
                    hiddenSearchInput.remove();
                    _this.$searchTemplateInput.each(function(index, el) {
                        el.value = '';
                    });
                    _this.$searchTemplateForm.submit();
                });

                this.$paginationFormInput.on('change keydown', function(e) {
                    //fix for IE
                    if (e.type === 'change' || (e.type === 'keydown' && e.which === 13)) {
                        _this.model.setPage($(this).val());
                        _this.applyFilter(true);
                    }
                });

                this.$paginationFormArrow.on('click', function(e) {
                    e.preventDefault();
                    _this.model.setPage($(this).attr('data-page-destination'));
                    _this.applyFilter(true);
                });

                // All block is clickable for XS screen
                this.$el.find('.designer-buttons-block').on('click', function() {
                    if (screen.isXs()) {
                        _this.goToPage(
                            $(this)
                                .find('.gallery-button')
                                .attr('href')
                        );
                    }
                });

                this.$el.find('#create-your-own-design').on('click', function(e) {
                    if ($(this).attr('href') === '#') {
                        e.preventDefault();
                        alert('Please select product size first');
                    }
                });

                this.$el.find('.template-actions-zoom').on('click', function() {
                    _this.zoomAction($(this));
                });

                this.$el.find('.template-actions-favorites, .gallery-favorite').on('click', function() {
                    _this.processFavoritesAction($(this));
                });

                this.$el.find('.color-preview').on('click', function() {
                    _this.colorPreviewAction($(this));
                });

                this.$el.find('#upload-your-design').on('click', function(e) {
                    if ($(this).attr('href') === '#') {
                        var slug = null;
                        if (_this.$productCriteria.length && _this.$productCriteria.val()) {
                            slug = _this.$productCriteria.val();
                        }

                        if (slug) {
                            _this.goToPage(
                                router.generate('/upload/{slug}', {
                                    slug: slug,
                                    new: 1
                                })
                            );
                        } else {
                            e.preventDefault();
                            alert('Please select product size');
                        }
                    }
                });

                // Handler for color picker radio
                if (this.$colorCriteriaLabel.length) {
                    this.$colorCriteriaLabel.on('click', function() {
                        var $colorCriteria = $(this).find('[name="color-criteria-radio"]');
                        if ($colorCriteria.is(':checked') || $(this).hasClass('color-picker-label-selected')) {
                            return;
                        }
                        if (screen.isXs()) {
                            var color = $(this)
                                .find('input')
                                .val();
                            if (_this.$colorCriteriaSelected.length > 0) {
                                _this.$colorCriteriaSelected.css({
                                    'background-color': '#' + color,
                                    display: 'inline-block'
                                });
                                _this.$removeSelectedColor.show();
                            } else {
                                const colorCriteriaSelected = $(_this.colorFilterSelectedTemplate({ color: color }));
                                _this.$el.find('.color-filter legend').append(colorCriteriaSelected);
                                _this.$colorCriteriaSelected = colorCriteriaSelected.filter('label');
                                _this.$removeSelectedColor = colorCriteriaSelected.filter('.icon-remove');
                                _this.addRemoveColorEvent(_this.$removeSelectedColor);
                            }
                        }

                        _this.model.set('color', $colorCriteria.val()).setPage(1);
                        _this.applyFilter();
                    });
                }

                if (this.$colorCriteriaSelected.length) {
                    this.addRemoveColorEvent(this.$removeSelectedColor);
                }

                // Handlers for dropdowns
                this.$templatesPerPageDropdown.on('change', function() {
                    _this.model.set('templatesPerPage', $(this).val()).setPage(1);
                });

                this.$el.find('.template-categories').on('change', function() {
                    var $selected = $(this).find(':selected');
                    if (!$selected.length) {
                        return;
                    }
                    if ($selected.data(_this.PARAM_QUERY)) {
                        _this.model.set(_this.PARAM_CATEGORIES, [$selected.data(_this.PARAM_QUERY)]);
                    }
                });

                this.$productUploadDropdown.on('change', function() {
                    var href = $(this)
                        .find(':selected')
                        .data('href');
                    $('#upload-product-criteria-button, #designer-upload .image-link').attr('href', href);
                });

                this.$productDesignBlankDropdown.on('change', function() {
                    $('#create-your-own-design-button').attr(
                        'href',
                        router.generate('/{productSlug}/create/blank_product/new', {
                            productSlug: $(this)
                                .find(':selected')
                                .val()
                        })
                    );
                });

                if (this.$productSizeRadio.length) {
                    this.$productSizeRadio.on('change', function() {
                        let galleryUrlSlug = _this.$productSizeRadio.filter(':checked').val();
                        let orientation = _this.$productSizeRadio.filter(':checked').data('orientation');
                        if (orientation) {
                            _this.model.set('orientation', orientation);
                        }
                        if (galleryUrlSlug) {
                            _this.model.set('galleryUrlSlug', galleryUrlSlug).setPage(1);
                            _this.updateHash();
                            _this.applyFilter();
                        }
                    });

                    this.$productSizeRadio.on('click', function() {
                        if ($(this).attr('checked') === 'checked' && _this.$showFavoritesButton.hasClass('active')) {
                            var galleryUrlSlug = _this.$productSizeRadioContainer.data('gallery-parent');
                            if (galleryUrlSlug) {
                                _this.model.set('galleryUrlSlug', galleryUrlSlug).set('page', 1);
                                _this.applyFilter();
                            }
                        }
                    });
                }

                this.$orientationRadio.on('change', function() {
                    _this.model.set('orientation', $(this).val()).set('page', 1);

                    _this.applyFilter();
                });

                this.$categoryCheckbox.on('change', function() {
                    var $subcategories = $(this)
                        .parent()
                        .find('.gallery-sub-categories input:checked');
                    var $parent = _this.$categoryCheckbox.filter('[data-slug="' + $(this).data('parent') + '"]');

                    if (this.checked) {
                        if ($parent.length) {
                            $parent.removeAttr('checked');
                        }
                        if ($subcategories.length) {
                            $subcategories.removeAttr('checked');
                        }
                    }

                    var categories = [];
                    _this.$categoryCheckbox.filter(':checked').each(function() {
                        if ($(this).data('slug')) {
                            categories.push($(this).data('slug'));
                        }
                    });

                    if (_this.$categoryCheckbox.filter(':checked').length === 1) {
                        _this.model.set(_this.PARAM_CATEGORY_TITLE, _this.$categoryCheckbox.filter(':checked')[0].dataset.title);
                    } else {
                        _this.model.set(_this.PARAM_CATEGORY_TITLE, null);
                    }

                    _this.model.set(_this.PARAM_CATEGORIES, categories);
                    _this.model.set('page', 1);

                    _this.applyFilter();
                });

                this.$templateCategoryDropdowns.on('change', function() {
                    _this.model.set(
                        _this.PARAM_CATEGORY_TITLE,
                        $(this)
                            .children('option:selected')
                            .data('title')
                    );
                });

                this.$showFavoritesButton.on('click', function(e) {
                    if (screen.isXs()) {
                        e.preventDefault();
                    }

                    _this.toggleFavorites();
                    if (_this.$showFavoritesButton.attr('href') === '#' && !screen.isXs()) {
                        e.preventDefault();
                        _this.showLoginPopup();
                    }
                });

                this.$overlayHandlers.on('click change', function(e) {
                    if (screen.isXs()) {
                        return;
                    }
                    if (!ONP.user.loggedIn && $(this).hasClass('favorites-link')) {
                        return true;
                    }
                    _this.progressOverlay.show();
                });

                this.$galleryMainSection.find('img.image').on('lazyloaded', function() {
                    let className = 'horizontal';
                    if ($(this).width() < $(this).height()) {
                        className = 'vertical';
                    } else if ($(this).width() === $(this).height()) {
                        className = 'square-circle';
                    }
                    $(this).addClass(className);
                });
            },

            /**
             * @param {jQuery} $el
             */
            addRemoveColorEvent: function($el) {
                var _this = this;
                $el.on('click', function() {
                    _this.model.set('color', null).setPage(1);
                    if (screen.isXs()) {
                        _this.$colorCriteriaSelected.hide();
                        _this.$removeSelectedColor.hide();
                    }
                    _this.applyFilter();
                });
            },

            /**
             * Query params
             *
             * @returns {object}
             */
            getQueryParams: function() {
                var params = {};

                if (this.model.get(this.PARAM_CATEGORY_TITLE)) {
                    params[this.PARAM_CATEGORY_TITLE] = this.model.get(this.PARAM_CATEGORY_TITLE);
                }

                params[this.PARAM_CATEGORIES] = this.model.get('categories').join('_');
                params[this.PARAM_GALLERY] = this.model.get('galleryUrlSlug');
                params[this.PARAM_PRODUCT_GROUP_NAME] = this.model.get('productGroupName');
                params[this.PARAM_COLOR] = this.model.get('color');
                params[this.PARAM_QUERY] = this.model.get('query');
                params[this.PARAM_PAGE] = this.model.get('page');
                params[this.PARAM_ORIENTATION] = this.model.get('orientation');
                params[this.PARAM_PER_PAGE] = this.model.get('templatesPerPage');

                if (this.$searchTemplateInput.val() !== '') {
                    params[this.PARAM_QUERY] = this.$searchTemplateInput.val();
                }
                return params;
            },

            /**
             * Go to page with applied filters
             *
             * @param {boolean} force
             */
            applyFilter: function(force) {
                var params = this.getQueryParams();

                if ($('.hidden-search-value').length) {
                    params['query'] = [...document.querySelectorAll('.hidden-search-value')]
                        .map(function(el) {
                            return el.value.trim();
                        })
                        .join('|');
                }

                if (screen.isXs() && this.$showFavoritesButton.hasClass('favorites-page') && !this.showFavorites) {
                    delete params[this.PARAM_QUERY]; //some bug with this on mobile
                }

                if (screen.isXs() && this.$showFavoritesButton.attr('href') === '#' && this.showFavorites && force) {
                    this.showLoginPopup();
                    return;
                }

                var route = router.generate('/search', params);

                if (this.$showFavoritesButton.hasClass('active') || this.showFavorites) {
                    route = router.generate('/{productGroupName}/templates/{gallery}/favorites', {
                        ...params,
                        productGroupName: params[this.PARAM_PRODUCT_GROUP_NAME],
                        gallery: params[this.PARAM_GALLERY]
                    });
                }

                if (!screen.isXs() || force) {
                    this.goToPage(route);
                }
            },

            /**
             * @param {string} url
             */
            goToPage: function(url) {
                this.progressOverlay.show();
                window.location = url;
            },

            /**
             * Deletes category for XS screen
             */
            deleteChosenCategory: function() {
                var params = {};

                params[this.PARAM_GALLERY] = this.model.get('galleryUrlSlug');
                params[this.PARAM_PRODUCT_GROUP_NAME] = this.model.get('productGroupName');

                this.goToPage(router.generate('/{productGroupName}/templates/{gallery}', params));
            },

            /**
             * Toggles filter popup
             */
            toggleFilter: function() {
                // Use class instead of .toggle() for resize
                this.$filterPopup.toggleClass('active');
                this.$galleryMainSection.toggleClass('filter-open');
            },

            toggleFavorites: function() {
                if (screen.isXs()) {
                    this.showFavorites = false;
                    this.$showFavoritesButton.toggleClass('active');
                    if (this.$showFavoritesButton.hasClass('favorites-page') && !this.$showFavoritesButton.hasClass('active')) {
                        this.showFavorites = false;
                    }
                    if (!this.$showFavoritesButton.hasClass('favorites-page') && this.$showFavoritesButton.hasClass('active')) {
                        this.showFavorites = true;
                    }
                }
            },

            /**
             * Toggles search input
             */
            toggleSearch: function() {
                this.$openFilterButton.toggleClass('search-open');
                this.$mobileSearchFilter.toggleClass('hidden');
                this.$openSearchButton.toggleClass('hidden');
            },

            initLoginPopup: function() {
                var self = this;
                this.loginPopup = new AuthPopup({
                    templateOptions: {
                        message: 'In order to save your favorites, you will need to login or create an account.'
                    },
                    onComplete: function() {
                        self.onLoginCompleted();
                    },
                    onCancel: function() {
                        self.$favoritesIcon = null;
                        self.loginPopup = null;
                    }
                });
            },

            zoomAction: function($zoomLink) {
                var $imageLink = $zoomLink.siblings('.template-image-link');
                var title = $imageLink.find('img').attr('alt');

                this.$zoomDialog.find('.title-tag').html(title);
                this.$zoomDialog.find('#btn-personalize').attr('href', $imageLink.attr('href'));

                var $imgFront = $('<img>').attr({
                    src: $zoomLink.data('front-url'),
                    title: title + ' ' + this.model.get('sideNames')[0],
                    alt: title + ' ' + this.model.get('sideNames')[0]
                });
                this.$zoomDialog.find('.preview-front .preview-image').html($imgFront);

                var $previewBack = this.$zoomDialog.find('.preview-back');
                if ($zoomLink.data('back-url')) {
                    var $imgBack = $('<img>').attr({
                        src: $zoomLink.data('back-url'),
                        title: title + ' ' + this.model.get('sideNames')[1],
                        alt: title + ' ' + this.model.get('sideNames')[1]
                    });
                    $previewBack.find('.preview-image').html($imgBack);
                    $previewBack.removeClass('hidden');
                } else {
                    $previewBack.addClass('hidden');
                }

                this.zoomPopup.open();
            },

            colorPreviewAction: function($colorPreviewLink) {
                if ($colorPreviewLink.hasClass('active')) {
                    return;
                }
                var $templateBlock = $colorPreviewLink.closest('.gallery-template-block');
                // highlight icon
                var $allVariants = $colorPreviewLink.siblings('.color-preview');
                $allVariants.removeClass('active');
                $colorPreviewLink.addClass('active');

                // fade images
                var $image = $templateBlock.find('.front-image img');
                var frontUrl = $colorPreviewLink.data('template-front');
                $image
                    .fadeTo(300, 0, function() {
                        $image.attr('src', frontUrl);
                    })
                    .fadeTo(300, 1);

                //switch url
                var $customizeButton = $templateBlock.find('.gallery-button');
                $customizeButton.attr('href', $colorPreviewLink.data('customize-url'));
                $templateBlock.find('.template-image-link').attr('href', $colorPreviewLink.data('customize-url'));

                //switch zoom links
                var $zoomButton = $templateBlock.find('.front-image .template-actions-zoom');
                $zoomButton.data('front-url', frontUrl);
                $zoomButton.data('back-url', $colorPreviewLink.data('template-back'));

                //switch favorites link
                var $templateImageBlock = $templateBlock.find('.gallery-template-image');
                $templateImageBlock.data('unique-id', $colorPreviewLink.data('template-unique-id'));
            },

            processFavoritesAction: function($favoritesIcon) {
                var self = this;
                var $template = $favoritesIcon.closest('.gallery-template-image');
                if ($template.length === 0) {
                    $template = $favoritesIcon.closest('.gallery-template-block').find('.gallery-template-image');
                }
                var id = $template.data('unique-id');
                if (id) {
                    var isForAddition = !$favoritesIcon.hasClass('active');
                    $.ajax({
                        url: router.generate('/gallery/favorite-template'),
                        data: {
                            id: id,
                            orientation: $template.data('orientation'),
                            isForAddition: isForAddition ? 1 : 0,
                            gallery: self.model.get('galleryUrlSlug')
                        },
                        type: 'POST',
                        success: function() {
                            self.updateFavoritesIcon($favoritesIcon, isForAddition);
                        },
                        error: function(jqXHR) {
                            if (jqXHR.status === 403) {
                                self.$favoritesIcon = $favoritesIcon;
                                self.showLoginPopup();
                            }
                        },
                        beforeSend: function() {
                            $favoritesIcon.addClass('load');
                        },
                        complete: function() {
                            $favoritesIcon.removeClass('load');
                        }
                    });
                }
            },

            showLoginPopup: function() {
                var self = this;
                self.initLoginPopup();
                self.loginPopup.showLoginFormAction();
            },

            onLoginCompleted: function() {
                this.$showFavoritesButton.show();

                var favoritesUrl = router.generate('/templates/favorites');
                if (this.model.get('productGroupName')) {
                    favoritesUrl = router.generate('/{productGroupName}/templates/{gallery}/favorites', {
                        gallery: this.model.get('galleryUrlSlug'),
                        productGroupName: this.model.get('productGroupName')
                    });
                }
                this.$showFavoritesButton.attr('href', favoritesUrl);
                if (this.$favoritesIcon === null) {
                    this.goToPage(favoritesUrl);

                    return;
                }
                this.processFavoritesAction(this.$favoritesIcon);
                // reload page to update vip bar, header etc
                document.location.reload();
            },

            updateFavoritesIcon: function($favoritesIcon, isForAddition) {
                if (isForAddition) {
                    $favoritesIcon.addClass('active');
                    $favoritesIcon.attr('title', 'Delete from favorites');
                } else {
                    $favoritesIcon.removeClass('active');
                    $favoritesIcon.attr('title', 'Add to favorites');
                }
            },

            updateHash: function() {
                var _this = this;

                $.getJSON(
                    router.generate('/api/v0/pricing/update-options-quantity-hash/{productSlug}', {
                        productSlug: _this.model.get('productSlug'),
                        itemId: _this.model.get('quantity')
                    })
                );
            }
        });
    }
);
